export enum SceneId {
    LOGIN_SCREEN = "LoginScreen",
    TITLE_SCREEN = "TitleScreen",
    NEW_GAME_SCREEN = "NewGameScreen",
    LOAD_GAME_SCREEN = "LoadGameScreen",
    GAME_MENU = "GameMenu",
    WORLD_MAP = "WorldMap",
    CASTLE = "Castle",
    VILLAGE = "Village",
    VILLAGE_HOUSE = "InnerHouse",
    BATTLE_SCENE = "BattleScene",
    BATTLE_MENU_SCENE = "BattleUIScene",
    INFO_LAYER_SCENE = "InfoLayer",
    MENU_SCENE = "MenuScene",
    INVENTORY_SCENE = "InventoryScene",
    BASIC_DIALOG = "BasicDialogScene",
    BUY_SCENE = "ItemBuyScene",
    DESIGN_SYSTEM_DEMO = "DesignSystemDemo",
}

export enum EnemySpritesheet {
    SNAKE = "Snake",
    RABBIT = "Rabbit",
    BEE = "bee",
    ORANGE_DRAGON = "OrangeDragon",
    BLUE_DRAGON = "BlueDragon",
}

export enum NPCId {
    GUILD_MANAGER = "Guild manager",
    RECRUITER = "recruiter",
    INNKEEPER = "innkeeper",
}

export enum Events {
    MESSAGE = "message",
    ATTACK = "attack",
    REFRESH_BATTLE_MENU = "refreshBattleMenu",
    BATTLE_READY = "battle_ready",
    BLOCK_BATTLE_INPUT = "blockBattleInput",
    UNBLOCK_BATTLE_INPUT = "unblockBattleInput",
}

export enum Tiled {
    WARP_LAYER = "warps",
    NPC_LAYER = "npcs",
    TARGET_SCENE_PROPERTY = "targetSceneId",
    NPC_ID_PROPERTY = "npc_id",
    SPRITESHEET_PROPERTY = "spritesheet",
    FRAME_INDEX_PROPERTY = "frame_index",
    WARP_TO = "warpTo",
    SPAWN_POINT = "spawn",
    SPAWN_HERO = "hero",
}

export enum SpriteSheets {
    PLAYER = "player",
}

export enum Direction {
    LEFT = "LEFT",
    RIGHT = "RIGHT",
    UP = "UP",
    DOWN = "DOWN",
}

export const Endpoints = {
    BASE_URL: (process.env.VITE_API_BASE_URL as string) || "http://localhost:8000/api/v1",
    ASSETS_URL: (process.env.VITE_ASSETS_BASE_URL as string) || "http://localhost:8000",
    SOCKETIO_BASE_URL: (process.env.VITE_SOCKETIO_URL as string) || "http://localhost:8001",
    ENEMY: "enemy",
    PLAYER: "player_character",
    SCENE: "scene",
    GAME_STATE: "game_state",
    GAME_CONFIGURATION: "game_configuration",
    INVENTORY: "inventory",
    NPC: "npc",
    BATTLE: "battle",
    MAP: "map",
    DIALOG: "dialog",
    PLAYER_CONFIGURATION: "player_configuration",
} as const;

export function getAssetUrl(path: string): string {
    const base = Endpoints.ASSETS_URL.replace(/\/$/, "");
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${base}${normalizedPath}`;
}

export enum DialogEvent {
    TALK_GUILD_MANAGER = "TALK_GUILD_MANAGER",
    TALK_RECRUITER = "TALK_RECRUITER",
}

export enum SocketEvents {
    LOAD_GAME_REQUEST = "load_game_request",
    LOAD_GAME_REQUEST_ACK = "load_game_request_ack",
    LOAD_GAME_REQUEST_ERROR = "load_game_request_error",

    // New Game Events (matches backend implementation)
    START_NEW_GAME = "start_new_game",
    NEW_GAME_STARTED = "new_game_started",
    NEW_GAME_ERROR = "new_game_error",

    // DEPRECATED: Old create game events (use START_NEW_GAME instead)
    // CREATE_GAME_REQUEST = "create_game_request",
    // CREATE_GAME_REQUEST_ACK = "create_game_request_ack",

    REFRESH_GAME_STATE = "refresh_game_state",
    REFRESH_GAME_STATE_REQUEST = "refresh_game_state_request",
    SAVE_CHARACTER_POSITION = "save_character_position",
    GAME_ERROR = "game_error",

    // Dialog Events (NEW - unified event-based system)
    DIALOG_START = "dialog_start",
    DIALOG_MESSAGE = "dialog_message",
    DIALOG_COMPLETE = "dialog_complete",
    DIALOG_ERROR = "dialog_error",

    // Dialog Interaction (player responses)
    DIALOG_CHOICE = "dialog_choice",
    DIALOG_CONTINUE = "dialog_continue",
    DIALOG_EXIT = "dialog_exit",

    // NPC Events
    // Note: NPC interactions handled via PLAYER_ACTION (server-authoritative)

    // Battle Events
    START_BATTLE = "start_battle",
    ATTACK = "attack",
    PLAYER_TURN_RESULT = "player_turn_result",
    BATTLE_STARTED = "battle_started",
    PLAYER_INPUT = "player_input",
    CANCEL_ACTION = "cancel_action",
    END_BATTLE = "end_battle",
    ATTACK_NOTIFICATION = "attack_notification",

    // Player Actions
    PLAYER_ACTION = "player_action",

    // Shop Events
    OPEN_BUY_WINDOW = "OPEN_BUY_WINDOW",
    OPEN_SELL_WINDOW = "open_sell_window",
}
